import React, { useRef, useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { SlideRenderer } from '../lib/renderer.js';
export const SlideView = ({ slide, slideWidth, slideHeight, width, height, renderMode = 'complete', onRenderComplete, onRenderError, }) => {
    const canvasRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const displayWidth = width || slideWidth;
    const displayHeight = height || slideHeight;
    useEffect(() => {
        const renderSlide = async () => {
            if (!canvasRef.current)
                return;
            try {
                setLoading(true);
                setError(null);
                const canvas = canvasRef.current;
                const renderer = new SlideRenderer(canvas, {
                    width: displayWidth,
                    height: displayHeight,
                    slideWidth,
                    slideHeight,
                });
                await renderer.renderSlide(slide, renderMode);
                setLoading(false);
                if (onRenderComplete) {
                    onRenderComplete();
                }
            }
            catch (err) {
                const error = err;
                setError(error.message);
                setLoading(false);
                if (onRenderError) {
                    onRenderError(error);
                }
            }
        };
        renderSlide();
    }, [slide, slideWidth, slideHeight, displayWidth, displayHeight, renderMode, onRenderComplete, onRenderError]);
    return (React.createElement(Box, { sx: { position: 'relative', width: displayWidth, height: displayHeight, overflow: 'hidden' } },
        React.createElement("canvas", { ref: canvasRef, width: displayWidth * 2, height: displayHeight * 2, style: {
                width: '100%',
                height: '100%',
                display: loading ? 'none' : 'block',
                objectFit: 'contain',
            }, "aria-label": "Slide preview", role: "img" }),
        loading && (React.createElement(Box, { sx: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'grey.100',
            } },
            React.createElement(CircularProgress, { size: 40 }))),
        error && (React.createElement(Box, { sx: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'error.light',
                color: 'error.contrastText',
                flexDirection: 'column',
                p: 2,
            } },
            React.createElement(Typography, { variant: "body2", sx: { fontWeight: 'bold', mb: 1 } }, "Error"),
            React.createElement(Typography, { variant: "caption" }, error)))));
};
export default SlideView;
//# sourceMappingURL=SlideView.js.map